<script setup lang="ts">
import { useKpiStore } from '@/stores/useKpiStore'
import { storeToRefs } from 'pinia'
import ChartBar from '@/components/data-visualization/charts/ChartBar.vue'

const kpiStore = useKpiStore()

const { kpiCallCreated, loadingCallCreatedKpi, errorCallCreated } = storeToRefs(kpiStore)
</script>

<template>
  <ChartBar
    :data="kpiCallCreated || []"
    title="Appels Créés"
    :loading="loadingCallCreatedKpi"
    :error="errorCallCreated"
  />
</template>
